/*
 * @Description:
 * @Author: zhanghao
 * @Date: 2024-08-01 16:44:35
 * @LastEditTime: 2024-09-18 17:33:38
 * @LastEditors: zhanghao
 */
// 初始化数据
const modal = {
  searchResult: [], //查询结果数据
  searchParams: {}, // 搜索传值
  total: 0, // 查询总数
  page: 1, // 当前页码
  size: 10, // 当前分页数
  tableLoading: false, // 列表loading
  action: '', //是否是编辑或者新增
  prepaymentNo: false, //如果是编辑详情状态则需要传预付款id
  isShowModal: false, //是否展示弹框
  modalTuttonLoading: false, // Modal按钮的Loading
  tabPopleLoading: false, //详情页的table的Loading
  count: 0,
  createTable: [],
  checkTicketNo: '', //勾票单号
  popTableData: {}, //勾票详情页数据
  // checkTicketResponse:{}, //勾票详情基础信息
  taxResponse: [], //勾票详情账单汇总
  invoiceResponseList: [], //勾票详情出入发票列表
  cloneInvoiceResponseListOBJ: {}, //点击编辑发票按钮保存下来的未修改状态本条数据
  fileList: [],
  bansList: [],
  toolState: 'add',
  iconLoading: false,
  deleteState: false,
  newData: {},
  invoiceTypeList: [], //发票类型下拉
  taxAllList: [], //所有税率下拉
  InvoiceEntry: false, // 是否拥有发票录入权限
  uploadFile: false, // 是否拥有上传权限
  InvoiceSubmission: false, // 是否拥有发票提交权限
  CheckDetailedList: false, // 是否拥有查看明细单权限
  InvoicePreservation: false, // 是否拥有发票保存权限
  ImportInvoice: false, // 是否拥有导入发票权限
  importTemplates: false, // 是否拥有发票批量导入模板权限
  AddInvoice: false, // 是否拥有添加发票权限
  modalLoading: false,
};
export default modal;
